import { CSSProperties, useRef } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import "./SunEditorCustom.style.scss";
import { UploadBeforeHandler, UploadInfo } from "suneditor-react/dist/types/upload";
import { message } from "antd";
import { UPLOAD_FILES_URL } from "constant";

type P_Props = {
  value?: string;
  content: any;
  onChange?: (content: any) => void;
  onPaste?: (e: any) => void;
  height?: string;

  className?: string;
  style?: CSSProperties;
};

const SunEditorCustomPresenter = (props: P_Props) => {
  const editor = useRef();

  const getSunEditorInstance = (sunEditor: any) => {
    editor.current = sunEditor;
  };

  const handleImageUpload = async (files: Array<File>, info: object, uploadHandler: UploadBeforeHandler) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", UPLOAD_FILES_URL, true);

      const formData = new FormData();
      formData.append("file", files[0], files[0].name);
      //console.log(blobInfo.filename())

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const progress = (e.loaded / e.total) * 100;
          console.log(`Upload progress: ${progress}%`);
          // Bạn có thể cập nhật trạng thái tải lên ở đây nếu cần
        }
      };

      xhr.onload = () => {
        if (xhr.status === 403) {
          reject({ message: "HTTP Error: " + xhr.status, remove: true });
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          reject("HTTP Error: " + xhr.status);
          return;
        }

        try {
          const json = JSON.parse(xhr.responseText);
          const imageUrl = json?.data[0]?.url;

          if (!json || typeof imageUrl !== "string") {
            reject("Invalid JSON: " + xhr.responseText);
            return;
          }

          resolve({
            success: 1,
            file: {
              url: imageUrl,
            },
          });
        } catch (error) {
          reject("Invalid JSON: " + xhr.responseText);
        }
      };

      xhr.onerror = () => {
        reject({ message: "Image upload failed", remove: true });
      };

      xhr.send(formData);
    });
  };

  return (
    <div className="html-editor">
      <SunEditor
        setOptions={{
          buttonList: [
            ["font", "fontSize", "formatBlock"],
            ["bold", "underline", "italic", "strike", "subscript", "superscript"],
            ["align", "horizontalRule", "list", "table"],
            ["fontColor", "hiliteColor"],
            ["outdent", "indent"],
            ["undo", "redo"],
            ["removeFormat"],
            ["outdent", "indent"],
            ["link", "image", "video"],
            ["preview", "print"],
            ["fullScreen", "showBlocks", "codeView"],
          ],
        }}
        getSunEditorInstance={getSunEditorInstance}
        height={props.height || "60vh"}
        onChange={props.onChange}
        setContents={props.content}
        onImageUploadBefore={(files, info, uploadHandler): any => {
          const formData = new FormData();
          console.log(105, files);
          formData.append("file", files[0]);

          fetch(UPLOAD_FILES_URL, {
            method: "POST",
            body: formData,
          })
            .then((res) => res.json())
            .then((data) => {
              uploadHandler({
                result: [{ url: data?.data[0]?.url, name: data?.data[0]?.fileName }] as any,
              });
            })
            .catch((err) => {
              console.error(err);
              message.error("Image upload failed!");
            });
        }}
      />
    </div>
  );
};

export default SunEditorCustomPresenter;
